<template>
    <modal :id="id" size="lg">
        <template slot="title">Image</template>
        <template slot="body">
            <img :src="imageUrl" :alt="title" style="width: 100%;">
        </template>
        <template slot="footer">
            <button @click="closeModal(id)" class="btn btn-default">Close</button>
        </template>
    </modal>
</template>
<script>
    export default {

        props: {
            id: {
                type: String,
                required: true,
            },
            imageUrl:{
                type: String,
                required: true,
            },
            title: {
                type: String,
                required: false,
                default: 'Acceptance Testing Software',
            }
        },

    }
</script>
